/**
 * Created by eladd on 8/31/2017.
 */
import {Pipe, PipeTransform} from "@angular/core";
import * as _ from "lodash";

@Pipe({
	name: 'cpSort'
})
export class SortPipe implements PipeTransform {
	transform<T>(array: Array<T>): Array<T>;
	transform<T>(array: Array<T>, key?: string): Array<T>;
	transform<T>(array: Array<T>, compareFn?: (a: T, b: T) => number): Array<T>;

	transform<T>(array: Array<T>, arg?: any) {
		if (!array){
			return array;
		}
		if (!arg) {
			return array.sort();
		} else if (typeof arg === 'string') {
			return _.sortBy(array, arg);
		} else if (typeof arg === 'function') {
			return [...array].sort(arg); //.sort is in-memory
		} else if (typeof arg === 'object' && Array.isArray(arg) && (<any[]>arg).every((field) => typeof field === 'string')) { // sort by multiple fields, adding secondary sort, tertiary sort, etc.
			return _.sortBy(array, arg);
		}

		throw new Error('SortPipe second argument must be a string or a function');
	}
}
